export default /* glsl */ `
float t = clamp(10.0 * (wipePosition - smoothstep(0.0, 1.0, vWipeFactor)), 0.0, 1.0);
vec4 diffuseColor = vec4( mix(diffuse, wipeColor, t), opacity );
`;
